import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê: ", -1)
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nơi trả hồ sơ: ", -1)
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Chọn loại lĩnh vực: ", -1)
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Xuất biên bản:", -1)
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Tải biên bản", -1)
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-4 p-lg-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Làm mới dữ liệu", -1)
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Không có thông tin danh sách hồ sơ. ")
const _hoisted_17 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_18 = { style: {"margin-top":"5px"} }
const _hoisted_19 = { class: "p-fluid" }
const _hoisted_20 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_21 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_23 = { id: "loadingExport" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Đang tải dữ liệu, vui lòng chờ...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách hồ sơ đã thanh toán" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
              selectionMode: "range",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100",
              onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar())),
              onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Dropdown, {
              id: "kind",
              modelValue: $setup.select,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.select) = $event)),
              options: $setup.location,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Vui lòng chọn ...",
              onChange: $setup.selectKind
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Dropdown, {
              id: "linhVuc",
              modelValue: $setup.selectLinhVuc,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectLinhVuc) = $event)),
              options: $setup.dsLinhVuc,
              optionLabel: "name",
              optionValue: "name",
              placeholder: "Vui lòng chọn ...",
              onChange: $setup.selectLV
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Button, {
              label: "Xử lý",
              icon: "pi pi-spinner",
              iconPos: "left",
              onClick: $setup.createExcelFileResult,
              disabled: $setup.listHSDVC.length < 1
            }, null, 8, ["onClick", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Button, {
              label: "Tải",
              severity: "warning",
              icon: "pi pi-download",
              iconPos: "left",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.downLoadFileExport($setup.file))),
              disabled: !$setup.file
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-sync",
              label: "Làm mới dữ liệu",
              severity: "danger",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectCalendar()))
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_DataTable, {
              value: $setup.listHSDVC,
              paginator: true,
              stripedRows: "",
              rows: 10,
              rowsPerPageOptions: [10,25,50],
              rowHover: true,
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              globalFilterFields: ['hoVaTen','soDienThoai','thoiGian'],
              currentPageReportTemplate: "Có tất cả {totalRecords} hồ sơ",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters) = $event)),
              style: {"font-size":"13px"}
            }, {
              empty: _withCtx(() => [
                _hoisted_16
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "chuHoSo",
                  header: "Chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "linhVuc",
                  header: "Lĩnh vực",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "nguoiNopHoSo",
                  header: "Người nộp HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "dienThoaiChuHoSo",
                  header: "Số điện thoại chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "diaChiChuHoSo",
                  header: "Địa chỉ chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "maSoHoSo",
                  header: "Mã số HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "dinhDanhChuHoSo",
                  header: "CCCD/CMND chủ HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "trichYeu",
                  header: "Trích yếu",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  header: "Lệ phí",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.lePhi)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "ngayNhan",
                  dataType: "date",
                  header: "Thời gian nhận HS",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "tranferTime",
                  dataType: "date",
                  header: "Thời gian thanh toán",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatDateTime(data.tranferTime)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "tienThanhToan",
                  header: "Số tiền đã thanh toán",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.formatCurrency(data.tienThanhToan)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Nơi trả HS",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    ($setup.checkKind(data.lePhi, data.tienThanhToan))
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          style: {"max-width":"200px"},
                          severity: "info",
                          label: "Tại phường",
                          icon: "pi pi-building-columns",
                          iconPos: "left"
                        }))
                      : (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          style: {"max-width":"200px"},
                          label: "Tại nhà",
                          severity: "danger",
                          icon: "pi pi-warehouse",
                          iconPos: "left"
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Biên lai ĐT",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    (data.link.length > 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          style: {"max-width":"150px"},
                          label: "Xem biên lai",
                          severity: "warning",
                          onClick: ($event: any) => ($setup.selectViewHD(data.id)),
                          icon: "pi pi-eye",
                          iconPos: "left"
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "filters"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Dialog, {
              visible: $setup.viewBL,
              "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (($setup.viewBL) = $event)),
              style: { width: '70vw'},
              breakpoints: { '1500px': '50vw', '1150px': '60vw' }
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_Button, {
                    label: "IN BIÊN LAI",
                    icon: "pi pi-print",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$refs.myPdf.print())),
                    severity: "danger"
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_vue_pdf_embed, {
                        ref: "myPdf",
                        source: $setup.hsdvc.link
                      }, null, 8, ["source"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Dialog, {
              header: "Đang xử lý",
              visible: $setup.loadingBar,
              "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (($setup.loadingBar) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_ProgressBar, {
                    mode: "indeterminate",
                    style: {"height":".3em"}
                  })
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_component_ConfirmDialog)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}